<div class="outer-container">
    <app-current-path></app-current-path>
    <div class="console-container">
        <div class="header-wrapper">
            <div class="title-wrapper">
                <span class="action-name">{{action}}</span>
            </div>
            <div class="input-wrapper">
            <input type="text" class="search-input" placeholder="Filter by Keyword"/>
            <button type="button" class="upload-btn" (click)="showUploadFileModal()">
                <span class="upload-icon--mask" [style.--icon]="'url(' + baseHref + '/assets/images/icon-upload.png)'"></span>
                    Upload
                </button>
            </div>
        </div>
        
        <div class="table-wrapper">
        <p-table
            [columns]="cols"
            [value]="dataToDisplay"
            [scrollHeight]="innerHeight + 'vh'"
            [scrollable]="true"
            [style]="{ width: '100%' }"
            [tableStyle]="{ 'min-width': '50rem' }"
            styleClass="p-datatable-sm"
            selectionMode="single"
            (onRowSelect)="onRowSelect($event)"
            [paginator]="true"
            [rows]="10"
        >
            <ng-template pTemplate="header" let-columns>
            <tr>
                <ng-container *ngFor="let col of cols">
                <th *ngIf="!col?.hide">
                    {{ col.label }}
                    <span class="fts">
                    <span class="filter" *ngIf="col.showFilter" (click)="toggleCustomColumnFilter(col.name)">
                        <ng-container *ngIf="col.filterVals; else notSelected">
                        <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                        </ng-container>
                        <ng-template #notSelected>
                        <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter.png" />
                        </ng-template>
                    </span>

                    <span class="sort" (click)="sortByColumn(col.name)">
                        <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                        <ng-container *ngIf="col.isAsc; else falseBlock">
                            <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                        </ng-container>
                        <ng-template #falseBlock>
                            <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                        </ng-template>
                        </ng-container>

                        <ng-template #others>
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                        </ng-template>
                    </span>
                    </span>
                </th>
                </ng-container>
            </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr [pSelectableRow]="rowData">
                <ng-container *ngFor="let col of cols">
                    <td class="ico-cell" *ngIf="!col?.hide && col.name === 'download'" (click)="downloadFile(rowData)">
                        <img alt=""
                        src="{{ baseHref }}/assets/images/icon-download.png"
                         class="iconButton" />
                    </td>
                    <td class="ico-cell" *ngIf="!col?.hide && col.name === 'remove'" (click)="removeFile(rowData)">
                        <img alt=""
                        src="{{ baseHref }}/assets/images/icon-delete.svg" class="iconButton" />
                    </td>
                    <td *ngIf="!col?.hide
                        && col.name === 'uploadedDate'">
                        {{ (rowData[col.name] | custdate)}}
                    </td>
                    <td *ngIf="!col?.hide 
                    && col.name === 'name'">
                        {{ rowData[col.name] }}
                    </td>
                    <td *ngIf="!col?.hide 
                    && col.name === 'uploadedBy'">
                        {{ rowData[col.name] }}
                    </td>
                </ng-container>
            </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length">No Data Available</td>
            </tr>
            </ng-template>
        </p-table>
        </div>
    </div>
</div>